import { FC } from 'react';

import AttachmentsSidebarSection from 'components/AttachmentsSidebarSection/AttachmentsSidebarSection';
import SidebarNavigation from 'components/SidebarNavigation';

import { selectActiveUserId } from 'features/applications/applicationsSelectors';
import {
  selectActiveJobseeker,
  selectJobseekers
} from 'features/jobseekers/jobseekersSelectors';
import { setActiveUserId } from 'features/sidebar/sidebarSlice';

import { useAppSelector } from 'hooks/useTypedRedux';

import { JobseekerAttachmentTypes } from 'constants/enums';
import { useTranslation } from 'react-i18next';

interface JobseekerDocumentsViewProps {
  isLoading: boolean;
  fetchJobseekerData: (jobseekerId: string) => Promise<void>;
}

const JobseekerDocumentsView: FC<JobseekerDocumentsViewProps> = ({
  isLoading,
  fetchJobseekerData
}: JobseekerDocumentsViewProps) => {
  const { t } = useTranslation()
  const jobseeker = useAppSelector(selectActiveJobseeker);
  const jobseekers = useAppSelector(selectJobseekers);
  const jobseekerId = useAppSelector(selectActiveUserId);

  const handleAttachmentChange = () => {
    if (!jobseekerId) {
      return;
    }
    fetchJobseekerData(jobseekerId);
  };

  const attachments = jobseeker?.attachments || [];

  const cvAttachments = attachments.filter(
    (el) => el.type === JobseekerAttachmentTypes.CV
  );

  const offerLetterAttachments = attachments.filter(
    (el) => el.type === JobseekerAttachmentTypes.OfferLetter
  );

  return (
    <aside>
      {isLoading ? (
        <div>{t('common.loading')}</div>
      ) : (
        <>
          <SidebarNavigation
            id={jobseekerId}
            data={jobseekers}
            action={setActiveUserId}
          />

          <AttachmentsSidebarSection
            attachmentType={JobseekerAttachmentTypes.CV}
            attachments={cvAttachments}
            name={t('attachment.cv')}
            placeholder={t('jobseekers.noCv')}
            onChange={handleAttachmentChange}
          />

          <AttachmentsSidebarSection
            attachmentType={JobseekerAttachmentTypes.OfferLetter}
            attachments={offerLetterAttachments}
            name={t('attachment.offerLetter')}
            placeholder={t('jobseekers.noOffer')}
            onChange={handleAttachmentChange}
          />
        </>
      )}
    </aside>
  );
};

export default JobseekerDocumentsView;
